import { useTranslation } from 'react-i18next'
import { Card, CardDescription, CardHeader, CardTitle } from '@/ui/components/common/Card'
import { useGetAllInvestigations } from '@/application/services/investigation.service'
import { useGetLeadGroups } from '@/application/services/lead.service'

/**
 * Three KPI cards: total leads across all ongoing investigations,
 * count of ongoing (active) investigations, and number of unique submitters.
 */
export function LiveStatsSection() {
  const { t } = useTranslation()
  const { data: investigations } = useGetAllInvestigations()
  const { data: leadGroups } = useGetLeadGroups()

  const ongoingInvestigations = (investigations ?? []).filter(
    (investigation) => investigation.status === 'active',
  )
  const ongoingIds = new Set(ongoingInvestigations.map((investigation) => investigation.id))
  const ongoingGroups = (leadGroups ?? []).filter((group) => ongoingIds.has(group.investigation.id))

  const totalLeads = ongoingGroups.reduce(
    (accumulator, group) => accumulator + group.leads.length,
    0,
  )
  const uniqueSubmitters = ongoingGroups.length
    ? new Set(ongoingGroups.flatMap((group) => group.leads).map((lead) => lead.submitterUsername))
        .size
    : 0

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{t('admin.live_stat_total_leads')}</CardDescription>
          <CardTitle className="text-3xl">{totalLeads}</CardTitle>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{t('admin.live_stat_active')}</CardDescription>
          <CardTitle className="text-3xl">{ongoingInvestigations.length}</CardTitle>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>{t('admin.live_stat_submitters')}</CardDescription>
          <CardTitle className="text-3xl">{uniqueSubmitters}</CardTitle>
        </CardHeader>
      </Card>
    </div>
  )
}
